import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';

import SaveIcon from '@mui/icons-material/Save';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty } from 'lodash';
import {
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MapsHomeWorkRoundedIcon from '@mui/icons-material/MapsHomeWorkRounded';
import Connectors from '../../../api/Connectors/Connectors';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';

import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

const MapsAdvancedCatastroField = props => {
  const {
    settingsAdvanced,
    serverConnection,
    connectors,
    setSettingsAdvanced,
    listComponentsAdvanced,
    setListComponentsAdvanced,
    catastroSettings,
    setCatastroSettings
  } = props;
  const streetViewOptions = [
    { name: 'View inside the app', value: 'inside' },
    { name: 'View inside in new tab', value: 'modal' },
    { name: 'window', value: 'View in new window' }
  ];
  const { viewInformation, streetTypeView } = catastroSettings;
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.CatastroComponent.name
  );
  const [downloadSettings, setDownloadSettings] = React.useState(settingsAdvanced.downloadLinks);
  const [viewInformationState, setViewInformationState] = React.useState(viewInformation || false);
  const [streetTypeViewState, setStreetTypeViewState] = React.useState(streetTypeView);

  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.CatastroComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(listComponentsAdvanced.CatastroComponent.iconSvg);
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.CatastroComponent.libraryIcon
  );

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        CatastroComponent: {
          name: listComponentsAdvanced.CatastroComponent.name,
          show: listComponentsAdvanced.CatastroComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        CatastroComponent: {
          name: listComponentsAdvanced.CatastroComponent.name,
          show: listComponentsAdvanced.CatastroComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  return (
    <>
      <Box display="column" width="50%" gab={1}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <MapsHomeWorkRoundedIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() =>
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                CatastroComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.CatastroComponent.show
                }
              })
            }
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={listComponentsAdvanced.CatastroComponent.iconFontawesome}
            startLibrary={listComponentsAdvanced.CatastroComponent.libraryIcon}
            svg={listComponentsAdvanced.CatastroComponent.iconSvg}
            startCategorySvg={listComponentsAdvanced.CatastroComponent.cetegorySvg}
          />
        </Box>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Base de datos</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Base de datos"
            size="small"
            value={downloadSettings.connector.name || ''}
            onChange={event => {
              const fullConector = connectors.find(element => element.name === event.target.value);
              setSettingsAdvanced(prev => ({
                ...prev,
                downloadLinks: {
                  ...prev.downloadLinks,
                  connector: fullConector
                }
              }));
              setDownloadSettings({
                ...downloadSettings,
                connector: fullConector
              });
            }}
          >
            {connectors.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Conexión IPS</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Conexión IPS"
            size="small"
            value={downloadSettings.server.name || ''}
            onChange={event => {
              const serverSelectedSearch = serverConnection.find(
                element => element.name === event.target.value
              );
              setSettingsAdvanced(prev => ({
                ...prev,
                downloadLinks: {
                  ...prev.downloadLinks,
                  server: serverSelectedSearch
                }
              }));
              setDownloadSettings({
                ...downloadSettings,
                server: serverSelectedSearch
              });
            }}
          >
            {serverConnection.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Street View Type</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Street View Type"
            size="small"
            value={streetTypeViewState}
            onChange={event => {
              setCatastroSettings({ ...catastroSettings, streetTypeView: event.target.value });
              setStreetTypeViewState(event.target.value);
            }}
          >
            {streetViewOptions.map(item => (
              <MenuItem key={item.value} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <Checkbox
            checked={viewInformationState}
            onChange={() => {
              setCatastroSettings({ ...catastroSettings, viewInformation: !viewInformationState });
              setViewInformationState(!viewInformationState);
            }}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="centerNotes"
          />
          Mostar botón localización
        </Box>
      </Box>
    </>
  );
};

export default withTracker(() => {
  const telemetryConnectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  const connectorsSub = Meteor.subscribe('connectors');

  return {
    loading: !telemetryConnectionsSub.ready() && !connectorsSub.ready(),
    connectors: Connectors.find({ deleted: { $eq: 'no' }, type: 'PostgreSQL' }).fetch(),
    serverConnection: TelemetryConnections.find({ serverType: { $in: ['IGP', 'IGPS'] } }).fetch()
  };
})(MapsAdvancedCatastroField);
MapsAdvancedCatastroField.defaultProps = {
  catastroSettings: { informationState: true, streetTypeView: 'window' }
};
MapsAdvancedCatastroField.propTypes = {
  serverConnection: PropTypes.array.isRequired,
  connectors: PropTypes.array.isRequired,
  settingsAdvanced: PropTypes.object.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired,
  setListComponentsAdvanced: PropTypes.func.isRequired,
  listComponentsAdvanced: PropTypes.object.isRequired,
  catastroSettings: PropTypes.object,
  setCatastroSettings: PropTypes.func.isRequired
};
